import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      const currentDate = new Date().toISOString().split('T')[0];

      window.gtag('config', 'G-E0JV6F9GJG', {
        page_path: location.pathname,
        page_title: document.title,
        page_referrer: document.referrer,
        page_date: currentDate, // custom parameter
      });
    }
  }, [location]);

  return null;
};

export default AnalyticsTracker;
